import MessageBrokerQueue from '@Services/MessageBroker/MessageBrokerQueue';
import { LIMIT_DEFAULT } from './constants';

class ImageRequest {
  _image = null;

  constructor({ url }) {
    this.url = url;
    this._promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  _loadListener = () => {
    this.resolve(this.url);
  };

  _errorListener = (e) => {
    this.reject(e);
  };

  get promise() {
    return this._promise;
  }

  send() {
    if (this._image) {
      this._image.removeEventListener('load', this._loadListener);
      this._image.removeEventListener('error', this._errorListener);
    }

    this._image = new Image();
    this._image.addEventListener('load', this._loadListener);
    this._image.addEventListener('error', this._errorListener);
    this._image.src = this.url;

    return this._promise;
  }

  destroy() {
    if (this._image) {
      this._image.removeEventListener('load', this._loadListener);
      this._image.removeEventListener('error', this._errorListener);
    }
    this._image = null;
  }
}

export const queue = new MessageBrokerQueue(LIMIT_DEFAULT);
export const updateLimit = (limit) => {
  if (limit && limit !== queue.limit) {
    queue.limit = limit;
  }
};

export const initImageRequest = async ({ url }) => {
  const sendRequest = (request) => request && request.send();
  const request = new ImageRequest({ url });

  queue.push(request);
  sendRequest(queue.next());

  request.promise.catch(Logger.error).finally(() => {
    queue.release(request);
    sendRequest(queue.next());
  });

  return request.promise;
};
